import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { defaultLogo } from "../../env";
import {
  CourseIcon,
  DashBoardIcon,
  MyCertificateIcon,
  MyDashBoardIcon,
  SupportIcon,
  Metabtn,
  RightIcon,
  EventsIcon,
  LeaderboardIcon,
} from "../../Assets/iconshere";
import Logo from "../../Assets/images/M.png";
import DownloadMeta from "./DownloadMeta";
import SimulanisIcon from "../../Assets/images/favicon.png";

const Sidebar = ({ sideBar, setSideBar }) => {
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);
  var navigate = useNavigate();
  const applications = useSelector((state) => state.applicationSlice).apps;
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [metaPop, setMetaPop] = useState(false);
  useEffect(() => {
    var path = location.pathname;
    var active = "dashboard";
    if (path.startsWith("/dashboard/")) active = "dashboard";
    else if (path.startsWith("/team/dashboard/")) active = "team-dashboard";
    else if (path.startsWith("/team/user/")) active = "team-dashboard";
    else if (path.startsWith("/team/")) active = "team-dashboard";
    else if (path.startsWith("/team/event/list/")) active = "team-dashboard";
    else if (path.startsWith("/team/session/list/")) active = "team-dashboard";
    else if (path.startsWith("/leaderboard")) active = "leaderboard";
    else if (path.startsWith("/events")) active = "events";
    else if (path.startsWith("/environments/list")) active = "environments";
    else if (path.startsWith("/metaverse")) active = "metaverse";
    setActiveTab(active);
  }, [location.pathname]);

  const handleClick = () => {
    if (window.innerWidth <= 767) {
      setSideBar(!sideBar);
    }
  };

  const forBodyLock = () => {
    if (window.innerWidth <= 767) {
      if (sideBar) {
        document.body.classList.add("body-lock");
      } else {
        document.body.classList.remove("body-lock");
      }
    }
  };

  return (
    <>
      <div className="mainside">
        <div className={sideBar ? "sidmenu active" : "sidmenu"}>
          <div className="mainsidelist">
            <ul>
              {userData.user.permissions.includes("METAVERSE.DASHBOARD.OWN") && (
                <li
                  className={`${activeTab == "dashboard" ? "active" : ""}`}
                  onClick={() => {
                    navigate(`/dashboard/${userData.user.uuid}`, { state: userData.user });
                    handleClick("dashboard");
                    forBodyLock();
                  }}
                >
                  {" "}
                  <MyDashBoardIcon />
                  <p className="ms-3"> My Dashboard </p>
                </li>
              )}

              {userData.user.permissions.includes("METAVERSE.DASHBOARD.TEAM") && (
                <li
                  className={`${activeTab == "team-dashboard" ? "active" : ""}`}
                  onClick={() => {
                    navigate(`/team/dashboard/${userData.user.group.uuid}`, {
                      state: {
                        name: userData.user.group.name,
                        avatar: userData.user.group.avatar,
                        uuid: userData.user.group.uuid,
                      },
                    });
                    handleClick("team-dashboard");
                    forBodyLock();
                  }}
                >
                  {" "}
                  <DashBoardIcon />
                  <p className="ms-3"> Team Dashboard </p>
                </li>
              )}

              {userData.user.permissions.includes("METAVERSE.LEADERBOARD") && (
                <li
                  className={`${activeTab == "leaderboard" ? "active" : ""}`}
                  onClick={() => {
                    navigate(`/leaderboard`, { state: userData.user });
                    handleClick("leaderboard");
                    forBodyLock();
                  }}
                >
                  {" "}
                  <LeaderboardIcon />
                  <p className="ms-3"> Leaderboard </p>
                </li>
              )}

              {userData.user.permissions.includes("METAVERSE.EVENTS") && (
                <li
                  className={`${activeTab == "events" ? "active" : ""}`}
                  onClick={() => {
                    navigate(`/events`, { state: userData.user });
                    handleClick("events");
                    forBodyLock();
                  }}
                >
                  {" "}
                  <EventsIcon />
                  <p className="ms-3">Events</p>
                </li>
              )}

              {userData.user.permissions.includes("METAVERSE.ENVIRONMENT.VIEW") && (
                <li
                  className={`${activeTab == "environments" ? "active" : ""}`}
                  onClick={() => {
                    navigate(`/environments/list`, { state: userData.user });
                    handleClick("environments");
                    forBodyLock();
                  }}
                >
                  {" "}
                  <MyCertificateIcon />
                  <p className="ms-3">Environments</p>
                </li>
              )}
            </ul>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-column">
            <button className="download-meta" onClick={() => setMetaPop(true)}>
              <img
                src={configData.config.logo}
                onError={(e) => {
                  e.target.src = defaultLogo;
                  e.onerror = null;
                }}
                referrerPolicy={"no-referrer"}
                alt=""
              />
              <span>
                <h6>{configData.config.name}</h6>
                <p>Download Now</p>
              </span>
            </button>
            <p className="pwrdby">
              {" "}
              Powered by{" "}
              <strong>
                <img src={SimulanisIcon} />
                <span>Simulanis</span>
              </strong>{" "}
            </p>
          </div>
        </div>
      </div>

      <DownloadMeta metaPop={metaPop} setMetaPop={setMetaPop} />
    </>
  );
};

export default Sidebar;
